"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextWithRequired = void 0;
var React = require("react");
var Icons_1 = require("../../Icons");
var TextWithRequired_styles_1 = require("./TextWithRequired.styles");
exports.TextWithRequired = (function (_a) {
    var LabelText = _a.LabelText, ShowRequiredIndicator = _a.ShowRequiredIndicator;
    return (React.createElement(TextWithRequired_styles_1.FormFieldLabelWrapper, null,
        LabelText,
        ShowRequiredIndicator &&
            React.createElement(TextWithRequired_styles_1.IconContainer, null,
                React.createElement(Icons_1.AsteriskIcon, { Width: "8px", Height: "8px" }))));
});
